export const VITE_ANALYTICS_ID = import.meta.env.VITE_ANALYTICS_ID
export const VITE_API_URL = import.meta.env.VITE_API_URL
export const VITE_APP_HOSTNAME = import.meta.env.VITE_APP_HOSTNAME
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
export const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS

export const BASE_URL = import.meta.env.BASE_URL
export const MODE = import.meta.env.MODE
export const VERSION = import.meta.env.npm_package_version
